import { PostHogMetricsResponse } from '@/types/composer-dashboard';
import { apiRequest } from '@/utils/api-request';

/**
 * Get PostHog analytics metrics for the composer dashboard.
 *
 * Returns web analytics data filtered to the organization's URLs:
 * - Unique visitors, pageviews, sessions
 * - Daily timeseries
 * - Top pages
 * - Activity heatmap
 *
 * @param orgId - Organization ID
 * @param days - Number of days to look back (1-90, defaults to 30)
 * @returns PostHog metrics for the organization
 */
export async function getPostHogMetrics(
  orgId: string,
  days: number = 30,
): Promise<PostHogMetricsResponse> {
  const response = await apiRequest<PostHogMetricsResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/posthog`,
    method: 'POST',
    target: 'workflow',
    body: { days },
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch PostHog metrics');
  }

  return response.data;
}
